import request from '@/utils/request';
import { Message } from 'element-ui';
const PREFIX = '/frontdesk';

import i18n from '@/utils/i18n';
// 查询实时房态列表
export function getRealTimeList(params) {
  return request({
    url: `${PREFIX}/hotel/room/state`,
    method: 'get',
    params,
  });
}
// 查询酒店房间楼层数
export function getHotelFloor(params) {
  return request({
    url: `${PREFIX}/hotel/floors`,
    method: 'get',
    params,
  });
}
// 查询公司会员折扣
export function queryHotelMemberByMemberNo(params) {
  return request({
    url: `/hotelMember/hotel/hotelMember/queryHotelMemberByMemberNo`,
    method: 'get',
    params,
  });
}

// 查询当前酒店下楼栋信息接
export function getHotelBuildings(params) {
  return request({
    url: `${PREFIX}/hotel/buildingNames`,
    method: 'get',
    params,
  });
}


// 统计房态
export function getRealTimeTypeList(params) {
  return request({
    url: `${PREFIX}/hotel/room/state/statistical`,
    method: 'get',
    params,
  });
}
// 置脏或置净
export function switchRoomClearState(id, params) {
  return request({
    url: `${PREFIX}/hotel/room/${id}/state`,
    method: 'put',
    data: params,
  });
}
// 设置房间状态（停用和启用）
export function switchRoomState(id, params) {
  return request({
    url: `${PREFIX}/hotel/room/${id}/state`,
    method: 'put',
    data: params,
  });
}
// 统计房态
export function getHotelState(params) {
  return request({
    url: `${PREFIX}/hotel/statistical`,
    method: 'get',
    params,
  });
}

// 获取房间停用信息
export function getRoomStopedInfo(id, params) {
  return request({
    url: `${PREFIX}/hotel/room/${id}/repair`,
    method: 'get',
    params,
  });
}
// 设置房间停用信息
export function settingRoomStopedInfo(id, params) {
  return request({
    url: `${PREFIX}/hotel/room/${id}/repair`,
    method: 'put',
    data: params,
  });
}
// 解除房间停用
export function enableRoom(roomId, repairId) {
  return request({
    url: `${PREFIX}/hotel/room/${roomId}/repair/${repairId}`,
    method: 'PATCH',
  });
}
// 获取渠道
export function fetchChannelList(data) {
  return request({
    url: `/admin/room/channel/available`,
    method: 'get',
    params: {
      joinModeId: 4,
    },
  });
}
// 查询会员
export function queryVipByKeywords(data) {
  return request({
    url: `/admin/auth/queryHotelMemberByKeyWords`,
    method: 'get',
    params: data,
  });
}
// `/room/goods/rely/goodsinfo`
// 查询产品列表
export function fetchProductList(data) {
  return request({
    url: `/dynamic/info/findMendianFullDayGoodsInfo`,
    method: 'get',
    params: data,
    passCodes: [10001, 10002], // 需要通过校验的code
  });
}

// 查询钟点房产品列表
export function fetchProductHourList(data) {
  return request({
    url: `/dynamic/info/findMendianHourGoodsInfo`,
    method: 'get',
    params: data,
    passCodes: [10001, 10002], // 需要通过校验的code
  });
}
// 查询证件类型
export function fetchCardTypeList(data) {
  return request({
    url: `/order/houseKeeper/getDocumentType`,
    method: 'get',
    params: data,
  });
}
// 办理入住-订单提交
export function submitOrder(data) {
  return request({
    url: `/order/houseKeeper/orderRoomHouseKeeperGuestStaySubmit`,
    method: 'post',
    data,
  });
}
export function errorDayPriceReport(productInfo) {
  return request({
    url: `/order/houseKeeper/recordProdectInfo`,
    method: 'post',
    data: {
      productInfo: JSON.stringify(productInfo),
    },
  });
}
// 订单提交-来自ebk订单
export function submitEBKBookingOrder(data) {
  return request({
    url: '/channel-agent/eb/order/pms/operationCreate',
    method: 'post',
    data,
  });
}
// 散客预订-订单提交
export function submitBookingOrder(data) {
  return request({
    url: `/order/houseKeeper/orderHouseKeeperSubmit`,
    method: 'post',
    data,
  });
}

// 房单详情-房单原单续住
export function orderRoomContinueStay(data) {
  return request({
    url: `/order/houseKeeper/orderRoomContinueStay`,
    method: 'post',
    data,
  });
}
// 房单换单续住，查询订单列表
export function orderRoomListContinueStayChange(data) {
  return request({
    url: `/order/houseKeeper/orderRoomListContinueStayChange`,
    method: 'post',
    data,
  });
}
// 房单换单续住，办理续住
export function orderRoomContinueStayChange(data) {
  return request({
    url: `/order/houseKeeper/orderRoomContinueStayChange`,
    method: 'post',
    data,
  });
}
// 远期房态
export function fetchFutureList(data) {
  return request({
    url: `${PREFIX}/hotel/room/state/remote`,
    method: 'get',
    params: data,
  });
}
// 查询远期房态库存
export function fetchFutureStoreList(data) {
  return request({
    url: `/room/goods/rely/roomsku`,
    method: 'get',
    params: data,
  });
}
// 查看操作日志
export function lookOperationLog(data) {
  return request({
    url: `${PREFIX}/hotel/queryRoomStateLog`,
    method: 'get',
    params: data,
  });
}
// 查询改酒店下所有房型
export function fetchRoomTypeList(data) {
  return request({
    url: `/dynamic/info/goods/cfg`,
    method: 'get',
    params: data,
  });
}

// 散客入住查询改酒店下所有房型
export function fetchRoomTypeListOfSanke(data) {
  return request({
    url: `/dynamic/info/listMendianGoodsInfo`,
    method: 'get',
    params: data,
  });
}
// 散客入住查询改酒店下所有房型包括钟点房
export function fetchRoomTypeListOfSankeHour(data) {
  return request({
    url: `/dynamic/info/listHourGoodsInfo`,
    method: 'get',
    params: data,
  });
}

// 排房接口
export function fetchAbleRoomList(data) {
  return request({
    url: `order/houseKeeper/queryPlanRoomList`,
    method: 'get',
    params: data,
  });
}

// 获取入住类型、客源类型字典接口
export function fetchDictionaryEnumList(data) {
  return request({
    url: `${PREFIX}/hotel/dicts`,
    method: 'get',
    params: data,
  });
}
// 查询酒店相关客户
export function queryCustomerListByHotelCode(data) {
  return request({
    url: `/customer/companies`,
    method: 'get',
    params: data,
  });
}
// 查询公司客户详情
export function getCustomerInfoById(id) {
  return request({
    url: `/customer/companies/${id}`,
    method: 'get',
  });
}
// 批量改房态
export function groupSwitchRoomStatus(data) {
  return request({
    url: `${PREFIX}/hotel/room/states`,
    method: 'put',
    data,
  });
}
// 查询钟点房
export function fetchHourProductionList(data) {
  return request({
    url: `/room/goods/rely/hourgoods`,
    method: 'get',
    params: data,
  });
}
// 查询钟点房(新)
export function fetchHourProductionListNew(data) {
  return request({
    url: `/dynamic/info/findMendianHourRoomGoodsInfo`,
    method: 'get',
    params: data,
  });
}
// 团队预订
export function groupBookingSubmit(data) {
  return request({
    url: `/order/houseKeeper/teamOrderHouseKeeperSubmit`,
    method: 'post',
    data,
  });
}
export const hourList = [
  { name: i18n.t('common.oneHour'), value: 1 },
  { name: i18n.t('common.twoHours'), value: 2 },
  { name: i18n.t('common.threeHours'), value: 3 },
  { name: i18n.t('common.fourHours'), value: 4 },
  { name: i18n.t('common.fiveHours'), value: 5 },
  { name: i18n.t('common.sixHours'), value: 6 },
  { name: i18n.t('common.sevenHours'), value: 7 },
  { name: i18n.t('common.eightHours'), value: 8 },
];

// 查询会员信息
export function fetchMemberByKeywords(data) {
  return request({
    url: `/hotelMember/hotel/hotelMember/pmsQueryMemberBalance`,
    method: 'get',
    params: data,
  });
}
// 获取短信验证码
export function getAuthCode(data) {
  return request({
    url: `/hotelMember/payment/getPaymentSmsCode`,
    method: 'post',
    data,
  });
}
// 校验手机验证码
export function checkVerifyCode(data) {
  return new Promise((resolve) => {
    request({
      url: `/hotelMember/payment/checkSmsCode`,
      method: 'get',
      params: data,
    }).then((res) => {
      if (res.code == 200 || res.code == 0) {
        resolve();
      } else {
        Message({
          message: res.msg,
          type: 'warning',
          duration: 2 * 1000,
        });
      }
    });
  });
}

/**
 *
 *门店客人信息模糊查询，姓名、手机号、证件号
 * @param {*} keyword
 * @param {*} sourcerList // 来源枚举：1: 单点会员, 2: 客源类型, 3:入住人
 */
export function autocompleteNameOrMobileOrDocNo(data) {
  return request({
    url: `/hotelMember/hotel/hotelGuest/queryHotelGuestInfo`,
    method: 'post',
    data,
  });
}
// 获取短信验证码
export function getFutureRoomStatusSummary(data) {
  return request({
    url: `/frontdesk/hotel/room/type/state/remote`,
    method: 'get',
    params: data,
  });
}
// 获取房态块的状态信息
export function fetchRoomStatusDetail(data) {
  return request({
    url: `/frontdesk/hotel/room/roomStateDetail`,
    method: 'get',
    params: data,
    trail: true,
  });
}
// 销售人员枚举
export function getSellerOptions(params) {
  return new Promise((resolve) => {
    request({
      url: `/hotelMember/salesman/query`,
      method: 'get',
      params,
    })
      .then((res) => {
        if (res.code === '0') {
          const list = res.data || [];
          resolve(
            list.reduce((pre, next) => {
              const { name, phone: code } = next;
              pre.push({ code, name, optionText: `${name}${code}` });
              return pre;
            }, [])
          );
        }
      })
      .catch(() => {
        resolve([]);
      });
  });
}
// 线上营收数据看板
export function onlineManage(data) {
  return request({
    url: `/rms/dashboard/onlineManage`,
    method: 'get',
    params: data,
  });
}

// 线上营收数据看板
export function queryHotelGroupInfo(data) {
  return request({
    url: `/admin/baseInfo/saasGroup/queryHotelGroupInfo`,
    method: 'get',
    params: data,
  });
}

export function roomTypeStatistical(data) {
  return request({
    url: `/frontdesk/hotel/roomTypeStatistical`,
    method: 'get',
    params: data,
  });
}
//房型、渠道统计
export function roomTypeAndChannelStatistical(data) {
  return request({
    url: `/frontdesk/hotel/roomTypeAndChannelStatistical`,
    method: 'get',
    params: data,
  });
}

export function getRoomTypeOccupiedInfo(data) {
  return request({
    url: `/frontdesk/hotel/room/getRoomTypeOccupiedInfo`,
    method: 'get',
    params: data,
  });
}

// 是否允许换房
export function fetchCheckDrag(data) {
  return request({
    url: `/order/houseKeeper/checkDrag`,
    method: 'post',
    data,
  });
}

// 拖拽房型升级校验
export function fetchCheckDragRoomUpgrade(data) {
  return request({
    url: `/order/houseKeeper/checkDragRoomUpgrade`,
    method: 'post',
    data,
  });
}

// 拖拽换房
export function featchChangeRoomByDrag(data) {
  return request({
    url: `/order/houseKeeper/changeRoomByDrag`,
    method: 'post',
    data,
  });
}

// 查询酒店是否支持设置分销权限
export function referralMarketingInfo() {
  return request({
    url: `/hotelMember/hotel/hotelMember/referralMarketingInfo`,
    method: 'get',
  });
}

// 分销配置设置
export function setHotelReferralMarketing(data) {
  return request({
    url: `/hotelMember/hotel/hotelMember/setHotelReferralMarketing`,
    method: 'post',
    data,
  });
}

export function memberReferralMarketingOpenInfo(params) {
  return request({
    url: `/hotelMember/hotel/hotelMember/memberReferralMarketingOpenInfo`,
    method: 'get',
    params
  });
}
// 根据证件号查询客人标签
export function queryHotelGuestLabelList(params) {
  return request({
    url: `/hotelMember/hotel/hotelGuest/labelList`,
    method: 'get',
    params,
  });
}
